module.exports = __webpack_public_path__ + "img/Jump Casting21.3b23395a.jpg";